import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";

export const ENERGY_PROJECTS: Layer = {
  id: ConstraintsCategory.RENEWABLE_ENERGY_PLANNING_DATABASE,
  layerType: ConstraintsLayerType,
  title: "Renewable energy projects",
  requiredFeatureAccess: [Feature.powerLayer],
  toggleable: true,
  group: LayerGroup.POWER,
  icon: "lt-layer-renewable-energy-projects",
  description: "Renewable energy capacity register",
  zoomConfig: {
    minVisualisationZoom: 10,
  },
  hideByDefault: true,
  layerConfig: {
    rootCategory: ConstraintsCategory.RENEWABLE_ENERGY_PLANNING_DATABASE,
    categorySchema: [{ key: "repd_solar" }, { key: "repd_wind" }, { key: "repd_battery" }, { key: "repd_other" }],
  },
};
